module.exports = __webpack_public_path__ + "img/mj8-warnings.9ae29c9a.png";